export default __webpack_public_path__ + "static/decorist-2-2e2c364f826b1e7936b87d434aeee4a7.webp";